import React from 'react'
import { Button } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

const DownloadPDFButton = () => {
    const settings = JSON.parse( localStorage.getItem( 'settings' ) );
    const downloadPDF = () => {
        const link = document.createElement( 'a' );
        link.href = settings && settings.resume_link; 
        link.download = settings && settings.resume_link;
        link.target = '_blank';
        document.body.appendChild( link );
        link.click();
        document.body.removeChild( link );
    };

    return (
        <Button type="submit" className="btn btn-green rounded-2 cbtn position-relative" onClick={ downloadPDF } >Download Resume <FontAwesomeIcon icon={faAngleRight} /></Button>
    )
}

export default DownloadPDFButton;